/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


function plusSlides(direction) {
  let parent = document.querySelector('.product__wrapper--thumbnails-left .thumbs-holder');
  let children = parent.childNodes;
  let heightToScroll = direction * (children.item(0).clientHeight + parseInt(window.getComputedStyle(children.item(0)).marginBottom));

  parent.scrollTo(0, parent.scrollTop + heightToScroll);
}
